import type { ReactNode } from 'react';

import { cn } from '~/utils/cn';

import type { ChipTone } from '../utils/lineage-chip-tone';

const TONE_CLASS: Record<ChipTone, string> = {
  success: 'bg-muted text-foreground border-border',
  warning: 'bg-warning-50 text-warning border-warning/20',
  danger: 'bg-error-50 text-error border-error/20',
  info: 'bg-info-50 text-info border-info/20',
  primary: 'bg-primary/10 text-primary border-primary/20',
  violet: 'bg-replaced-50 text-replaced border-replaced/20',
  neutral: 'bg-muted text-muted-foreground border-border',
};

interface Props {
  tone?: ChipTone;
  className?: string;
  children: ReactNode;
}

/** Small rounded status/label chip shared by the product master, lineage and images screens. */
export function LineageChip({ tone = 'neutral', className, children }: Props) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        TONE_CLASS[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
